import React from 'react'
import PropTypes from 'prop-types'

const Footer = props => (<footer id="footer" style={props.timeout
    ? {
      display: 'none'
    }
    : {}}>
  <p className="copyright">
    &copy; 2018{' '}
    <a href="https://www.lostcoastdev.com" target="_blank">
      Lost Coast Dev
    </a>{' '}
    | Design:{' '}
    <a href="https://html5up.net" target="_blank">
      HTML5 UP
    </a>{' '}
    | Built with:{' '}
    <a href="https://www.gatsbyjs.org/" target="_blank">
      Gatsby.js
    </a>{' '}
    | Deployed with:{' '}
    <a href="https://netlify.com/" target="_blank">
      Netlify
    </a>
  </p>
</footer>)

Footer.propTypes = {
  timeout: PropTypes.bool
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js